import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";

import "./assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/scss/argon-dashboard-react.scss";

import AdminLayout from "./layouts/Admin/Admin";
import AuthLayout from "./layouts/Auth/Auth";
import AuthContextProvider, { AuthContext } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import LoadingContextProvider from "./context/LoadingContext";
import UserTypeContextProvider from "./context/UserTypeContext";
import DocumentTypeContextProvider from "./context/DocumentContext";
import SettingsContextProvider from "./context/SettingsContext";
import ContactContextProvider from "./context/ContactContext";

const rootElement =
  document.getElementById("root") ?? document.createElement("div");
const root = ReactDOM.createRoot(rootElement);

function CustomRoute() {
  const { authenticated, loadingButton, handleLogout } =
    useContext(AuthContext);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const tokenLocal = localStorage.getItem("token");

  useEffect(() => {
    document.body.setAttribute("translate", "no");
  }, []);

  // useEffect(() => {
  //   const initSite = async () => {
  //     await handleLogout();
  //     navigate("/auth/login");
  //   };

  //   if (!location.pathname.includes("/auth") && location.pathname !== "/admin/sign-document") {
  //     initSite();
  //   }

  // }, []);

  // setInterval(() => {
  //   handleLogout();
  // }, 60 * 60 * 1000);

  if (loadingButton) {
    return <Route>Carregando...</Route>;
  }

  const configuration = {
    onUpdate: (registration: ServiceWorkerRegistration) => {
      if (registration && registration.waiting) {
        setShowUpdateModal(true);
      }
    },
  };

  serviceWorkerRegistration.register(configuration);

  const handleUpdateConfirmation = () => {
    serviceWorkerRegistration.unregister();
    caches.keys().then(function (cacheNames) {
      cacheNames.forEach(function (cacheName) {
        caches.delete(cacheName);
      });
    });
    window.location.reload();
    handleLogout();
  };

  if (location.pathname.startsWith("/admin/sign-document")) {
    return (
      <>
        <Routes>
          <Route path="/admin/*" element={<AdminLayout />} />
          <Route path="*" element={<Navigate to="/admin/" replace />} />
        </Routes>
        <Modal isOpen={showUpdateModal}>
          <ModalBody>
            Uma nova versão do aplicativo está disponível. Deseja recarregar a
            página para aplicar as alterações?
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleUpdateConfirmation}>
              OK
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  } else if (!authenticated || loadingButton || !tokenLocal) {
    return (
      <Routes>
        <Route path="/auth/*" element={<AuthLayout />} />;
        <Route path="*" element={<Navigate to="/auth/*" replace />} />
      </Routes>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/admin/*" element={<AdminLayout />} />
        <Route path="*" element={<Navigate to="/admin/" replace />} />
      </Routes>
      <Modal isOpen={showUpdateModal}>
        <ModalBody>
          Uma nova versão do aplicativo está disponível. Deseja recarregar a
          página para aplicar as alterações?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleUpdateConfirmation}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

root.render(
  <BrowserRouter>
    <ToastProvider>
      <LoadingContextProvider>
        <AuthContextProvider>
          <UserTypeContextProvider>
            <SettingsContextProvider>
              <DocumentTypeContextProvider>
                <ContactContextProvider>
                  <CustomRoute />
                </ContactContextProvider>
              </DocumentTypeContextProvider>
            </SettingsContextProvider>
          </UserTypeContextProvider>
        </AuthContextProvider>
      </LoadingContextProvider>
    </ToastProvider>
  </BrowserRouter>
);
